<template>
  <div class="content content--sub">
    <div class="bg-img">
      <img src="../assets/images/hero-performance.jpg">
    </div>

    <MyHeader :breadcrumbItems="[

        {
          name: section.name,
          path: `/${$route.params.companySlug}/performance`
        },
      ]"/>

    <header class="content-header">
      <h1>{{section.name}}</h1>
      <button :class="['article-list-button', {active: showList}]" @click="showList = ! showList"><i class="icon-list"></i></button>
    </header>

    <!-- tabs for mobile -->
    <transition name="fade">
      <div class="article-list" v-if="showList">
        <div class="tabs-vertical">
          <ul class="tabs-inner">
            <li v-for="tab in tabs" :key="tab.id">
              <a :class="{'active': activeTab === tab.id}"  @click="activeTab = tab.id; showList = false">
                {{tab.name}}
                <i class="icon-arrow"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </transition>

    <div class="container main-content--tabbed">
      <div class="row">
        <div class="col-lg-3 d-none d-lg-block">
          <div class="tabs-vertical">
            <ul class="tabs-inner">
              <li v-for="tab in tabs" :key="tab.id">
                <a :class="{'active': activeTab === tab.id}"  @click="activeTab = tab.id; showList = false">
                  {{tab.name}}
                  <i class="icon-arrow"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="row boxes-row">
            <div class="col-lg-4" v-for="box in achievements" :key="box.idAchievement">
              <PerformanceBox :box="box"></PerformanceBox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/general/Header'
import PerformanceBox from "@/components/performance/PerformanceBox";

export default {
  name: "Performance",
  components: {PerformanceBox, MyHeader },
  data () {
    return {
      showList: false,
      tabs: [
        {
          id: 1,
          name: 'Achievements'
        }
      ],
      activeTab: 1,
    }
  },
  mounted() {
    this.$store.dispatch("getAchievements")
    window._paq.push(['setDocumentTitle', this.section.name]);
    window._paq.push(['trackPageView']);
  },
  computed: {
    achievements() {
      return this.$store.getters.achievements
    },
    section() {
      return this.$store.getters.menu().find((item) => {
        return item.routeName === 'Performance'
      })
    }
  },
}
</script>
